import React from "react";
import Button, { ButtonProps } from "web/react/components/__LEGACY__/LEGACY_button/button";

type PrimaryButtonProps = Omit<ButtonProps, "styleType">;

export default function PrimaryButton(props: PrimaryButtonProps): JSX.Element {
    return <Button styleType="primary" {...props} />;
}
